import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

// Import components
import { Input } from 'components/elements';
import { Tooltip } from 'antd';

// Import icons
import { ReactComponent as HintIcon } from 'assets/icons/ic_more_info.svg';

// Import styles utilities
import { customMinResponsive, size } from 'components/styles';

const RegisterFormField = ({
	type = 'text',
	field,
	name = 'pin',
	autoComplete = 'true',
	form: { touched, errors },
	placeholder,
	disabled = false,
	marginBottom = '1.5',
	tooltipHintText,
	showTooltipIcon = false
}) => {
	return (
		<FormFieldStyled marginBottom={marginBottom}>
			<Tooltip
				title={tooltipHintText}
				trigger="focus"
				placement="bottomRight"
				overlayClassName="antd-customRegisterTooltip"
			>
				<Input
					className={`${
						touched[field.name] && errors[field.name] ? 'errors' : ''
					}`}
					disabled={disabled}
					type={type}
					name={name}
					autoComplete={autoComplete}
					placeholder={placeholder}
					{...field}
				/>
				{showTooltipIcon && <CustomIcon />}
			</Tooltip>
			{touched[field.name] && errors[field.name] && (
				<FormError>{errors[field.name]}</FormError>
			)}
		</FormFieldStyled>
	);
};

const FormFieldStyled = styled.div`
	position: relative;
	margin-bottom: ${({ marginBottom }) => marginBottom}rem;
`;

const FormError = styled.span`
	display: block;
	margin-top: 1rem;
	font-size: 1.2rem;
	color: ${({ theme }) => theme.red};
	text-align: left;
	padding-left: 0.7rem;
`;

const CustomIcon = styled(HintIcon)`
	position: absolute;
	top: 20px;
	right: 20px;
	transform: translate(50%, -50%);
	width: 2.75rem;
	height: 2.75rem;

	${customMinResponsive(
		size.semi,
		css`
			width: 2rem;
			height: 2rem;
		`
	)}
`;

RegisterFormField.propTypes = {
	type: PropTypes.string.isRequired,
	field: PropTypes.object.isRequired,
	form: PropTypes.shape({
		touched: PropTypes.object.isRequired,
		errors: PropTypes.object.isRequired
	}),
	placeholder: PropTypes.string.isRequired,
	autoComplete: PropTypes.string,
	tooltipHintText: PropTypes.string,
	showTooltipIcon: PropTypes.bool
};

export default RegisterFormField;
